// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"52902c36","239":"a4564377","455":"9551f050"}[chunkId] + ".chunk.js";
};